import { render, staticRenderFns } from "./partner-achievement.vue?vue&type=template&id=d6b4159c&"
import script from "./partner-achievement.vue?vue&type=script&lang=js&"
export * from "./partner-achievement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports